<template>
  <section class='user-center-list'>
    <ul class="video-item">
      <li
        v-for="(items, index) in data"
        :key="index"
      >
        <template v-for="item in items">
          <div
            :key="item.snowId"
            v-if="!item.isDeleted"
            @click="handleGoPlay(item)"
            v-lazy:background-image="item.coverUrl"
          >
            <div
              class="live-state font10"
              v-if="item.liveState === 1 && type === 'live'"
            >
              <img
                src="@/assets/icon/list-live.png"
                alt=""
              >
              直播中
            </div>
            <div class="bottom">
              <img
                src="@/assets/icon/view-icon.png"
                alt=""
              >
              <span>{{item.pvCount || item.uvCount || 0}}</span>
            </div>
            <div class="bottom-color"></div>
          </div>
          <div
            class="video-empty"
            :key="item.snowId"
            v-if="item.isDeleted"
          >
            <div
              class="no-video-icon"
              @click="handleTipNoMsg"
            >
              <img
                src="@/assets/icon/no-video.png"
                alt=""
              >
            </div>
            <div class="bottom">
              <img
                src="@/assets/icon/view-icon.png"
                alt=""
              >
              <span>0</span>
            </div>
            <div class="bottom-color"></div>
          </div>
        </template>

        <div
          v-if="items.length == 1"
          class="white-bg"
        >
        </div>
        <div
          v-if="items.length == 1 || items.length == 2"
          class="white-bg"
        >
        </div>
      </li>

    </ul>
  </section>
</template>

<script>
export default {
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    type: [String],
  },
  methods: {
    handleTipNoMsg() {
      this.$toast({
        duration: 1000,
        message: '该作品已不存在',
      });
    },
    handleGoPlay(params) {
      const {
        snowId,
      } = params;
      if (snowId === this.$route.query.snowId) return;
      this.$store.commit('keepAlive', 'userCenter');
      this.$emit('goPlay', params);
    },
  },
};
</script>

<style lang='less' scoped>
.user-center-list {
  .video-item{
    li{
      display: flex;
      >div{
        flex: 1;
        height: 180px;
        background-size: 100%;
        position: relative;
        background-repeat:no-repeat;
        background-position:center;
        background-color: #000000;

        .bottom{
          position: absolute;
          bottom: 0;
          z-index: 1;
          height: 22px;
          display: flex;
          align-items: center;
          >img{
            width: 16px;
            height: 16px;
            margin: 0 6px;
            vertical-align: bottom;
          }
          >span{
            color: #ffffff;
            font-size: 12px;
          }
        }
        .bottom-color {
          background: linear-gradient(180deg,rgba(135,135,135,0), #000000);
          width: 100%;
          position: absolute;
          bottom: 0;
          height: 22px;
          opacity: 0.5;
        }
      }
      .white-bg {
        background: #fff;
      }
      // >div:nth-child(2) {
      //   border-right: 1px solid #000000;
      //   border-left: 1px solid #000000;
      // }
    }
    .video-empty{
      background: #7E7E7E;
      .no-video-icon{
        position: relative;
        height: 100%;
        img{
          width: 40px;
          position: absolute;
          top: 50%;
          transform:translate3d(-50%, -50%, 0);
          left: 50%;
        }
      }
    }
    .live-state{
      position: absolute;
      background: rgba(0,0,0,.25);
      border-radius: 10px;
      padding: 0 2px;
      color: #ffffff;
      img{
        width: 20px;
        height: 20px;
        border-radius: 50%;
        margin-right: 5px;
      }
    }
  }
}
</style>
